<script lang="ts" setup>
import CityLogoIcon from '~/assets/icons/logo/icon.svg'
import CityLogoTextDE from '~/assets/icons/logo/text/de.svg'
import CityLogoTextEN from '~/assets/icons/logo/text/en.svg'

withDefaults(defineProps<{
  maxWidth?: string
  showLogo?: boolean
  showIcon?: boolean
}>(), {
  maxWidth: '300px',
  showLogo: true,
  showIcon: false,
})

const { locale } = useI18n()
</script>

<template>
  <div class="shrink-0 w-full flex justify-center items-center pb-5 grow">
    <CityLogoIcon
      v-if="showIcon"
      class="block overflow-visible"
      :style="{ height: '100%', width: '100%', maxWidth }"
    />
    <template v-else-if="showLogo">
      <CityLogoTextDE
        v-if="locale === 'de'"
        class="block overflow-visible px-2"
        :style="{ height: '100%', width: '100%', maxWidth }"
      />
      <CityLogoTextEN
        v-else
        class="block overflow-visible px-2 py-1.5"
        :style="{ height: '100%', width: '100%', maxWidth }"
      />
    </template>
  </div>
</template>
